export const listChangedNameFilers = {
  accountsFilters: [{ name: 'csEngineer', newName: 'customerSuccessEngineer' }]
};
